export { default as LifestylesAuthorsFilter } from './LifestylesAuthorsFilter';
